module.exports = require("moment");


//////////////////
// WEBPACK FOOTER
// external "moment"
// module id = 5
// module chunks = 0